<div class="container">
    <div class="row">
        <div class="col-md-12 col-lg-12 col-12">
            <div class="student-search">
                <h1 class="student_title">Student Well Being</h1>
                <label class="student-search__label" for="studentSearchInput">Search student (Admission No / Mobile /
                    Name)</label>
                <div class="student-search__box">
                    <input id="studentSearchInput" type="text" class="student-search__input form-control"
                        [(ngModel)]="searchCriteria" (ngModelChange)="onSearchCriteriaChange($event)"
                        placeholder="Search by Adm No, Mobile No , Name" autocomplete="off"
                        (input)="onSearchInput($event)" (keydown)="onSearchKeydown($event)"
                        (focus)="onSearchBoxFocus()"
                        aria-label="Search student by admission number, mobile number or name" />
                    <button type="button" class="student-search__icon-btn" (click)="onSearchIconClick($event)"
                        aria-label="Search">
                        <i class="fa fa-search student-search__icon" aria-hidden="true"></i>
                    </button>
                    <ul *ngIf="shouldShowSearchDropdown" class="student-search__list" role="listbox">
                        <ng-container *ngIf="shouldShowRecentList">
                            <li class="student-search__list-heading">Recent searches</li>
                            <li *ngFor="let item of recentSearchList" class="student-search__item student-search__item--recent"
                                role="option" (click)="selectCachedStudent(item)">
                                <span class="student-search__item-name">{{ item.searchName || item.searchKey }}</span>
                                <span class="student-search__item-meta">{{ item.searchSelected }}</span>
                                <span class="student-search__item-meta" *ngIf="item.parentName">{{ item.parentName }}</span>
                            </li>
                        </ng-container>
                        <li *ngIf="shouldShowSearchResults" class="student-search__list-heading">Search results</li>
                        <li *ngFor="let item of searchResults" class="student-search__item" role="option"
                            (click)="selectStudent(item)">
                            <span class="student-search__item-name">{{ item.name || item.studentName }}</span>
                            <span class="student-search__item-meta">{{ item.admNo || item.searchSelected }}</span>
                            <span class="student-search__item-meta" *ngIf="item.mobileNo">{{ item.mobileNo }}</span>
                            <span class="student-search__item-meta" *ngIf="item.parentName">{{ item.parentName }}</span>
                        </li>
                    </ul>
                </div>
                <p *ngIf="searchLoading" class="student-search__hint">Searching...</p>
                <p *ngIf="searchNoResults && searchCriteria.trim().length >= 3"
                    class="student-search__hint student-search__hint--warn">No students found.</p>
            </div>
            <div class="student_infocards_flex">
                <div class="student-card" *ngIf="showSelectedStudentCard">
                    <h6 class="student_profile_info">Student profile Info</h6>
                    <div class="student-bgcolor">
                        <div class="student-card__photo">
                            <img *ngIf="hasStudentImage" class="student-card__photo-img" [src]="studentImageUrl"
                                alt="Student photo" />
                            <i *ngIf="!hasStudentImage" class="fa-regular fa-image student-card__photo-icon"
                                aria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="student-card__info">
                       
                        <div class="student-card__field">
                            <span class="student-card__field-icon" aria-hidden="true">
                                <i class="fa-solid fa-id-card"></i>
                            </span>
                            <span class="student-card__field-text">Admission No : <span class="student-card__name">{{
                                    selectedAdmNo }}</span></span>
                        </div>
                        <div class="student-card__field">
                            <span class="student-card__field-icon" aria-hidden="true">
                                <i class="fa-solid fa-user"></i>
                            </span>
                            <span class="student-card__field-text">Name : <span class="student-card__name">{{
                                    selectedDisplayName }}</span></span>
                        </div>
                        <div class="student-card__field">
                            <span class="student-card__field-icon" aria-hidden="true">
                                <i class="fa-solid fa-user"></i>
                            </span>
                            <span class="student-card__field-text">Parent Name : <span class="student-card__name">{{
                                    selectedDisplayParentName
                                    }}</span></span>
                        </div>
                        <div class="student-card__field">
                            <span class="student-card__field-icon" aria-hidden="true">
                                <i class="fa-solid fa-location-dot"></i>
                            </span>
                            <span class="student-card__field-text">Campus : <span class="student-card__name">{{
                                    selectedDisplayCampus }}</span></span>
                        </div>
                        <div class="student-card__field">
                            <span class="student-card__field-icon" aria-hidden="true">
                                <i class="fa-solid fa-user-graduate"></i>
                            </span>
                            <span class="student-card__field-text">Student Type : <span class="student-card__name">{{
                                    selectedDisplayStudentType
                                    }}</span></span>
                        </div>
                       
                    </div>
                </div>
                <div class="adaptability" *ngIf="showAdaptabilitySection">
                    <div class="student_make_choice" *ngIf="!showHistoryView">
                        <div class="adaptability__top-actions">
                            <div class="adaptability__lang-field">
                                <label class="adaptability__lang-label" id="langSelectLabel">Select language</label>
                                <div class="adaptability__lang-select"
                                    [class.adaptability__lang-select--open]="langDropdownOpen">
                                    <button type="button" class="adaptability__lang-trigger"
                                        (click)="toggleLangDropdown($event)" aria-labelledby="langSelectLabel"
                                        [attr.aria-expanded]="langDropdownOpen" aria-haspopup="listbox">
                                        <span class="adaptability__lang-trigger-text">{{ languageLabel }}</span>
                                        <i class="fa-solid fa-chevron-down adaptability__lang-chevron"
                                            aria-hidden="true"></i>
                                    </button>
                                    <ul *ngIf="langDropdownOpen" class="adaptability__lang-menu" role="listbox"
                                        aria-labelledby="langSelectLabel">
                                        <li *ngFor="let lang of languageOptions" role="option"
                                            class="adaptability__lang-item"
                                            [class.adaptability__lang-item--selected]="currentLang === lang.value"
                                            [attr.aria-selected]="currentLang === lang.value"
                                            (click)="selectLanguage(lang.value)">
                                            <span class="adaptability__lang-item-label">{{ lang.label }}</span>
                                            <i *ngIf="currentLang === lang.value"
                                                class="fa-solid fa-check adaptability__lang-item-tick"
                                                aria-hidden="true"></i>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <button type="button" class="adaptability__history-btn" (click)="onCheckHistory()"
                                [disabled]="historyLoading">
                                <i class="fa" [ngClass]="showHistoryView ? 'fa-chevron-left':'fa-history' "
                                    aria-hidden="true"></i>&nbsp;
                                {{ showHistoryView ? 'Back to Evaluation' : 'Check your History' }}
                            </button>
                        </div>

                        <div class="adaptability__header">
                            <h1 class="adaptability__title">Make your choice</h1>
                            <p *ngIf="loading" class="adaptability__loading">Loading questions...</p>
                        </div>

                        <!-- <p *ngIf="errorMessage" class="adaptability__error">{{ errorMessage }}</p> -->

                        <form *ngIf="!loading && questions.length" class="adaptability__form" (ngSubmit)="onSubmit()">
                            <!-- Scrollable area: questions 1 to N only -->
                            <div class="adaptability__scroll">
                                <div *ngFor="let q of questions; let i = index" class="adaptability__question">
                                    <p class="adaptability__question-text">{{ i + 1 }}. {{ getQuestionText(q) }}</p>

                                    <!-- TEXT option: show textarea (max 1000 characters) -->
                                    <ng-container *ngIf="hasTextOption(q)">
                                        <div class="adaptability__text-wrap">
                                            <textarea class="adaptability__textarea" [value]="getTextAnswer(q.id)"
                                                (input)="onTextChange(q.id, $any($event.target).value)"
                                                [attr.maxlength]="maxChars"
                                                placeholder="Type your answer (max 150 characters)"
                                                rows="4"></textarea>
                                            <span class="adaptability__charcount">{{ getTextCharCount(q.id) }} / {{
                                                maxChars
                                                }}</span>
                                        </div>
                                    </ng-container>

                                    <!-- SINGLE: only non-TEXT options -->
                                    <ng-container *ngIf="showSingleOptions(q)">
                                        <div class="adaptability__options">
                                            <label *ngFor="let opt of getOptionsByRank(q.options)"
                                                class="adaptability__option adaptability__option--radio"
                                                [class.adaptability__option--hidden]="isOptionText(opt)"
                                                [class.adaptability__option--selected]="!isOptionText(opt) && isSelectedSingle(q.id, opt.id)">
                                                <input *ngIf="!isOptionText(opt)" type="radio"
                                                    class="adaptability__option-input" [name]="q.id" [value]="opt.id"
                                                    [checked]="isSelectedSingle(q.id, opt.id)"
                                                    (change)="onSelectSingle(q.id, opt.id)" />
                                                <span *ngIf="!isOptionText(opt)" class="adaptability__option-control"
                                                    aria-hidden="true"></span>
                                                <span class="adaptability__option-label option_font"
                                                    *ngIf="!isOptionText(opt)">{{ getOptionLabel(opt) }}</span>
                                            </label>
                                        </div>
                                    </ng-container>

                                    <!-- MULTIPLE: only non-TEXT options -->
                                    <ng-container *ngIf="showMultipleOptions(q)">
                                        <div class="adaptability__options">
                                            <label *ngFor="let opt of getOptionsByRank(q.options)"
                                                class="adaptability__option adaptability__option--checkbox"
                                                [class.adaptability__option--hidden]="isOptionText(opt)"
                                                [class.adaptability__option--selected]="!isOptionText(opt) && isSelectedMultiple(q.id, opt.id)">
                                                <input *ngIf="!isOptionText(opt)" type="checkbox"
                                                    class="adaptability__option-input" [value]="opt.id"
                                                    [checked]="isSelectedMultiple(q.id, opt.id)"
                                                    (change)="onToggleMultiple(q.id, opt.id)" />
                                                <span *ngIf="!isOptionText(opt)" class="adaptability__option-control"
                                                    aria-hidden="true"></span>
                                                <span class="adaptability__option-label option_font"
                                                    *ngIf="!isOptionText(opt)">{{ getOptionLabel(opt) }}</span>
                                            </label>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <p *ngIf="submitValidationMessage" class="adaptability__validation-msg">{{
                                submitValidationMessage }}</p>
                            <p *ngIf="submitSuccessMessage" class="adaptability__success-msg">{{ submitSuccessMessage }}
                            </p>
                            <!-- <p *ngIf="submitErrorMessage" class="adaptability__error-msg">{{ submitErrorMessage }}</p> -->
                            <footer class="adaptability__footer">
                                <span class="adaptability__progress"><span class="adaptability__progress-count">{{
                                        answeredCount
                                        }}</span><span class="adaptability__progress-total">/{{ totalCount
                                        }}</span></span>
                                <button type="submit" class="adaptability__submit" [disabled]="submitting">
                                    {{ submitting ? 'Submitting…' : 'Submit Your Evaluation' }}
                                </button>
                            </footer>
                        </form>
                    </div>

                    <div class="feedback-history" *ngIf="showHistoryView">
                        <div class="adaptability__top-actions">
                            <button type="button" class="adaptability__history-btn" (click)="onCheckHistory()"
                                [disabled]="historyLoading">
                                <i class="fa" [ngClass]="showHistoryView ? 'fa-chevron-left':'fa-history' "
                                    aria-hidden="true"></i>&nbsp;
                                {{ showHistoryView ? 'Back to Evaluation' : 'Check your History' }}
                            </button>
                        </div>
                        <p *ngIf="historyLoading" class="feedback-history__loading">Loading feedback history...</p>

                        <ng-container *ngIf="!historyLoading">
                            <div *ngIf="feedbackHistory.length" class="feedback-history__dates">
                                <button *ngFor="let entry of feedbackHistory; let i = index" type="button"
                                    class="feedback-history__date-tab"
                                    [class.feedback-history__date-tab--active]="selectedHistoryDateIndex === i"
                                    (click)="selectHistoryDate(i)">
                                    {{ formatHistoryDate(entry.feedBackDate) }}
                                </button>
                            </div>

                            <div *ngIf="feedbackHistory.length" class="feedback-history__card">
                                <div class="feedback-history__card-header">
                                    <h2 class="feedback-history__card-title">{{ historyFeedbackCountLabel }}</h2>
                                </div>
                                <div class="feedback-history__card-body">
                                    <div *ngFor="let q of getSelectedHistoryQuestions(); let i = index"
                                        class="feedback-history__question">
                                        <p class="feedback-history__question-text">Q{{ i + 1 }}. {{ q.question }}</p>
                                        <div *ngFor="let opt of getSelectedHistoryOptions(q)"
                                            class="feedback-history__answer" [ngStyle]="{
                                                'border-color': getHistoryRankStyles(getHistoryOptionRank(opt)).border,
                                                'background-color': getHistoryRankStyles(getHistoryOptionRank(opt)).background
                                            }">
                                            <span class="feedback-history__rank"
                                                [ngStyle]="{ 'background-color': getHistoryRankStyles(getHistoryOptionRank(opt)).circle }">
                                                {{ getHistoryOptionRank(opt) }}
                                            </span>
                                            <span class="feedback-history__answer-text">{{ getHistoryOptionLabel(opt)
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <p *ngIf="!feedbackHistory.length" class="feedback-history__empty">
                                No feedback history found for this student.
                            </p>
                        </ng-container>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>


<!-- loading -->

<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>